/**
 * @generated SignedSource<<52b500945595a5ddfd97f7b093b92e15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RateDisplayOptions = "BUNDLED" | "SEPARATE";
import { FragmentRefs } from "relay-runtime";
export type GolfRoundControls_Booking$data = {
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly club: {
          readonly supportsPrivate: boolean;
        } | null | undefined;
        readonly publicBookingPermissionSet: {
          readonly rateDisplay: RateDisplayOptions | null | undefined;
        } | null | undefined;
      };
    };
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BundledRateAndTransportSelect_Booking" | "CourseLayoutControl_Booking" | "GolfPlayerRateControl_Booking">;
  readonly " $fragmentType": "GolfRoundControls_Booking";
};
export type GolfRoundControls_Booking$key = {
  readonly " $data"?: GolfRoundControls_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"GolfRoundControls_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GolfRoundControls_Booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CourseLayoutControl_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GolfPlayerRateControl_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BundledRateAndTransportSelect_Booking"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PublicBookingPermissionSet",
                  "kind": "LinkedField",
                  "name": "publicBookingPermissionSet",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rateDisplay",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "48e2dc7cac50832b0860456906316e9e";

export default node;
